
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, State } from 'vuex-class';
import { DesignAction } from '@/store/Design/DesignRoot';

// Utils
import { hasSearch } from '@/utils/Helper';
import ErrorService from '@/utils/ErrorService';

// API
import { getDesignFilters } from '@/utils/api/Designs';

// Interfaces
import Project from '@/ship/Models/Project';
import { IDesignFiltersItem } from '@/ship/Models/Design';

// Components
import VDesigningProjectCard from '@/components/Designing/VDesigningProjectCard.vue';
import VPageHeader from '@/components/VPageHeader.vue';
import VSearch from '@/components/VSearch.vue';

@Component({
    components: {
        VDesigningProjectCard,

        VPageHeader,
        VSearch,
    },
})
export default class DesigningProjects extends Vue {
    @Action GET_ALL_PROJECTS!: () => Promise<Project[]>;
    @DesignAction SET_DESIGN_PAGE_LOADING!: (loading: boolean) => void;

    @State projects!: Project[] | null;

    public search = '';
    public designingProjectsFilter: IDesignFiltersItem[] | null = null;

    public async created() {
        this.SET_DESIGN_PAGE_LOADING(true);

        try {
            await this.GET_ALL_PROJECTS();
            this.designingProjectsFilter = (await getDesignFilters()).projects;
        } catch (error) {
            ErrorService.handleApiError(error);
        } finally {
            this.SET_DESIGN_PAGE_LOADING(false);
        }
    }

    get designingProjects() {
        return this.projects?.filter(({ id }) =>
            this.designingProjectsFilter?.find((filterProject) => filterProject.id === id),
        );
    }

    get filteredProjects() {
        return (
            this.designingProjects?.map((project) => ({
                isActive: hasSearch(project.project, this.search),
                project,
            })) ?? []
        );
    }
}
